// extracted by mini-css-extract-plugin
export default {"AdContainer":"VermontLeaderboardAd-module__AdContainer__Y7MRX","Ad":"VermontLeaderboardAd-module__Ad__ePKXC"};